import axios from 'axios';
import config from '../config';

export const putHubspotReferrer = ({ data }) =>
  axios.put(`${config?.apiHost}/v1/accounts/referrer`, data, { withCredentials: true });



// WEBPACK FOOTER //
// ./src/utils/HubspotData.js